export default __webpack_public_path__ + "static/media/emajohn.300b7a1e.PNG";